import products from "../data/products.json";
import { deriveRatings } from "./ratings";
import type { Product, SourceProduct } from "./types";

const sourceData = products as SourceProduct[];

export const productData: Product[] = sourceData.map((item) => ({
  name: `${item.brand} ${item.model}`,
  brand: item.brand,
  category: item.productGroup,
  isAvailable: item.isAvailable,
  price: item.price.amount,
  currency: item.price.currency,
  priceDate: item.price.date,
  testProgram: item.testProgram,
  publicationDate: item.publicationDate,
  image: item.image,
  detailUrl: item.detailUrl,
  ...deriveRatings(item)
}));

export function getCategories(items: Product[]): string[] {
  return ["Alle", ...new Set(items.map((item) => item.category))];
}
